import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=2487f152"
import script from "./assets.ts?vue&type=script&lang=js&external"
export * from "./assets.ts?vue&type=script&lang=js&external"
import style0 from "./assets.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports